import React from 'react';
import PropTypes from 'prop-types';
import { useFlag } from '@openfeature/react-sdk';
import { applications } from '@alli/frontend-common';
import MenuItemNew from './MenuItemNew';

export default function SideMenu({
    menuItems,
    bottomMenuItems,
    currentClient,
    activeApp,
    activeSubnavItem,
    navigateToUrl,
    isSidebarOpen,
}) {
    const shouldSkipSubNavItem = id => {
        // Add feature flaged subnavs to skip
        return false;
    };

    const renderMenuItem = item => {
        const subNav = item?.subNav?.reduce((acc, id) => {
            const subItem = item.subNavItems[id];
            if (subItem) {
                if (shouldSkipSubNavItem(id)) {
                    return acc;
                }
                acc.push({
                    ...subItem,
                    href: applications.renderClientUrl(currentClient, subItem),
                });
            }
            return acc;
        }, []);

        const finalItem = {
            ...item,
            href: applications.renderClientUrl(currentClient, item),
            subNav,
        };

        return (
            <MenuItemNew
                key={`sidemenu-${item.id}`}
                item={finalItem}
                isActive={activeApp === item.id}
                activeSubnavItem={activeSubnavItem}
                navigateToUrl={navigateToUrl}
                isSidebarOpen={isSidebarOpen}
            />
        );
    };

    return (
        <>
            <div className="w-full">{menuItems.map(renderMenuItem)}</div>
            <div className="w-full border-t border-gray-400 dark:border-blue-gray-800 pt-2 mt-2">
                {bottomMenuItems.map(renderMenuItem)}
            </div>
        </>
    );
}

const MenuItem = PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    iconPath: PropTypes.node,
});

SideMenu.propTypes = {
    currentClient: PropTypes.shape({
        id: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
    }),
    activeApp: PropTypes.string.isRequired,
    navigateToUrl: PropTypes.func.isRequired,
    isSidebarOpen: PropTypes.bool,
    menuItems: PropTypes.arrayOf(MenuItem).isRequired,
    bottomMenuItems: PropTypes.arrayOf(MenuItem).isRequired,
};
